import dayjs from "dayjs";

export const handleDateKeyDown = (e) => {
    const input = e.target;
    const value = input.value;
    const cursor = input.selectionStart;

    const allowedKeys = [
        "Backspace", "Tab", "ArrowLeft", "ArrowRight",
        "Delete", "Home", "End", "Enter", "Escape"
    ];
    if (allowedKeys.includes(e.key)) return;

    if (/^[a-zA-Z]$/.test(e.key)) {
        e.preventDefault();
        return;
    }


    if (e.key === "/") {
        if ((value.match(/\//g) || []).length >= 2) {
            e.preventDefault();
            return;
        }

        if (value[cursor - 1] === "/") {
            e.preventDefault();
            return;
        }

        if (cursor !== 1 && cursor !== 4) {
            e.preventDefault();
            return;
        }
    }


    if (e.key === "/" && cursor === 1) {
        e.preventDefault();
        const d = value.charAt(0) || "0";
        input.value = `0${d}/`;
        input.setSelectionRange(3, 3);
        return;
    }

    if (cursor === 1) {
        const first = parseInt(value.charAt(0) || "0");
        const second = parseInt(e.key);
        const day = first * 10 + second;

        if (day < 1 || day > 31) {
            e.preventDefault();
            input.value = `0${first}/`;
            input.setSelectionRange(3, 3);
            return;
        }

        setTimeout(() => {
            if (!input.value.includes("/")) {
                input.value += "/";
                input.setSelectionRange(3, 3);
            }
        }, 0);

        return;
    }

    if (e.key === "/" && cursor === 4) {
        e.preventDefault();
        const m = value.charAt(3) || "0";
        input.value = value.slice(0, 3) + `0${m}/`;
        input.setSelectionRange(6, 6);
        return;
    }

    if (cursor === 4) {
        const first = parseInt(value.charAt(3) || "0");
        const second = parseInt(e.key);

        if (first === 0 && second === 0) {
            e.preventDefault();
            input.value = value.slice(0, 3) + "01/";
            input.setSelectionRange(6, 6);
            return;
        }

        const month = first * 10 + second;

        if (month < 1 || month > 12) {
            e.preventDefault();
            input.value = value.slice(0, 3) + `0${first}/`;
            input.setSelectionRange(6, 6);
            return;
        }

        setTimeout(() => {
            if (input.value.charAt(5) !== "/") {
                input.value += "/";
                input.setSelectionRange(6, 6);
            }
        }, 0);

        return;
    }


    if (cursor >= 6) {
        const year = value.slice(6).replace(/\D/g, "");
        if (year.length >= 4) {
            e.preventDefault();
            return;
        }
    }
};



export const handleDateInput = (e) => {
    let val = e.target.value.replace(/[^0-9/]/g, "");

    const parts = val.split("/");
    let day = parts[0] || "";
    let month = parts[1] || "";
    let year = parts[2] || "";

    if (day.length === 2) {
        if (parseInt(day) < 1) day = "01";
        if (parseInt(day) > 31) day = "31";
    }

    if (month.length === 2) {
        const m = parseInt(month);

        if (m === 0) month = "01";
        else if (m < 1) month = "01";
        else if (m > 12) month = "12";
    }


    if (year.length > 4) year = year.slice(0, 4);

    let newVal = day;
    if (month) newVal += "/" + month;
    if (year) newVal += "/" + year;

    e.target.value = newVal;
};



export const handleDateBlur = (e, onValidDate) => {
    let v = e.target.value;
    if (!v) return;

    const [d, m, y] = v.split("/");
    if (!d || !m || !y) return;

    const final = `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y.padStart(4, "0")}`;
    const obj = dayjs(final, "DD/MM/YYYY");

    if (obj.isValid()) {
        onValidDate(obj.toDate());
        e.target.value = final;
    }
};

export const blockPaste = (e) => e.preventDefault();
